module.exports = __webpack_public_path__ + "static/media/assistAmericaEmergency.fa08aba4.svg";